export default __webpack_public_path__ + "static/media/gallery-17.7a3511f2.jpg";